<template>
  <div class="ds-data-panel ds-data-panel-one" :style="panelStyle" :shadow="showShadow" :size="size" @click="onClick">
    <slot name="item" v-bind="$props">
      <div v-if="showIcon" class="ds-data-panel-one-icon" :style="iconBoxStyle">
        <slot name="itemLeft" v-bind="$props">
          <DsfIcon :name="$replace(iconName, panelData)" :style="iconStyle"></DsfIcon>
        </slot>
      </div>
      <div class="ds-data-panel-one-info" :textalign="textAlign">
        <slot name="itemRight" v-bind="$props">
          <div class="ds-data-panel-one-info-wrap">
            <div class="ds-data-panel-one-info-number">
              {{ $replace(number, panelData) || 0 }}<span v-if="unit" class="ds-data-panel-one-info-unit">{{ unit }}</span>
            </div>
            <div v-if="showTitle" class="ds-data-panel-one-info-name ellipsis" :title="title">
              {{ title || "" }}
            </div>
          </div>
        </slot>
      </div>
    </slot>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfDataPanelOne",
  ctrlCaption: "数字看板-样式一",
  mixins: [$mixins.control],
  props: {
    // 面板圆角
    borderRadius: {
      type: String,
      default: () => "4px"
    },
    // 高度
    height: {
      type: String,
      default: () => "88px"
    },
    // 背景颜色
    backgroundColor: {
      type: String,
      default: () => ""
    },
    // 显示阴影
    showShadow: {
      type: Boolean,
      default: () => false
    },
    // 图标名称
    iconName: {
      type: String,
      default: () => "jihuabeifen2"
    },
    //图标颜色
    iconColor: {
      type: String,
      default: () => ""
    },
    // 图标背景色
    iconBackgroundColor: {
      type: String,
      default: () => ""
    },
    // 显示图标
    showIcon: {
      type: Boolean,
      default: () => true
    },
    // 标题
    title: {
      type: String,
      default: () => "标题"
    },
    // 显示标题
    showTitle: {
      type: Boolean,
      default: () => true
    },
    // 描述
    desc: {
      type: String,
      default: () => "描述"
    },
    // 显示描述
    showDesc: {
      type: Boolean,
      default: () => true
    },
    // 获取数据url
    dataUrl: {
      type: String,
      default: () => ""
    },
    // 点击跳转url
    toUrl: {
      type: String,
      default: () => ""
    },
    // 数据
    number: {
      type: String,
      default: () => "0"
    },
    // 数据单位
    unit: {
      type: String,
      default: () => ""
    },
    // 面板数据
    panelData: {
      type: Object,
      default: () => {}
    },
    // 是否在组里
    isGroup: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: String,
      default: ""
    },
    textAlign: {
      type: String,
      default: "center"
    },
    toConfig: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // 面板样式
    panelStyle() {
      let { backgroundColor, height, panelData = {}, $replace } = this;

      let style = {
        height
      };
      if (backgroundColor) style.backgroundColor = $replace(backgroundColor, panelData);
      return style;
    },
    // 图标盒子样式
    iconBoxStyle() {
      let { borderRadius, iconBackgroundColor, panelData = {}, $replace } = this;
      return {
        borderRadius,
        backgroundColor: $replace(iconBackgroundColor, panelData)
      };
    },
    iconStyle() {
      let { iconColor } = this;
      let style = {};
      if (iconColor) style.color = iconColor;
      return style;
    }
  },
  data() {
    return {};
  },
  created() {
    !this.isDesign && this.getData();
  },
  methods: {
    onClick() {
      let { toConfig, title } = this;
      this.$open({ ...toConfig, title });
    },
    getData() {
      let { dataUrl, isGroup } = this;
      if (!dataUrl || isGroup) return;
      this.$http
        .get(dataUrl)
        .then(({ data }) => {
          if (data && data.success) {
            this.$emit("update:panelData", data.data);
          } else {
            dsf.layer.message(data.message, false);
            this.$emit("update:panelData", {});
          }
        })
        .catch((ex) => {
          let message = dsf.isDef(ex.message) ? message : ex;
          dsf.layer.message(message, false);
          this.$emit("update:panelData", {});
        })
        .finally();
    }
  }
});
</script>
